const reportedUnresolvedBindings = new Set();

export function readBoundContextName(vm) {
  const binding = vm.optionValues?.context
    ?? vm.configuration?.options?.context
    ?? vm.configuration?.context
    ?? null;
  const name = binding?.entityContext;
  return typeof name === "string" && name ? name : null;
}

function scopedContextId(scoped, name) {
  return scoped?.[name]?.entityPkUrlVars?.id ?? scoped?.[name]?.pk?.id;
}

function reportUnresolvedBinding(vm, boundName, scoped, pages) {
  const identifier = String(vm?.identifier ?? vm?.elementIdentifier ?? "");
  const elementId = identifier.split(":")[0];
  const elementType = vm?.$options?.name ?? "";
  const key = `${elementId}:${elementType}:${boundName}`;
  if (reportedUnresolvedBindings.has(key)) {
    return;
  }
  reportedUnresolvedBindings.add(key);

  const rowContexts = Object.keys(scoped ?? {});
  const pageContexts = Object.keys(pages ?? {});

  // eslint-disable-next-line no-console
  console.error(
    `[dce] context binding "${boundName}" resolved to no entity — <${elementType || "element"}>`
    + ` ${elementId || "(unidentified)"} will render but cannot act on anything.`
    + " A named binding never falls back to another context, so nothing here is bound."
    + ` Rebind the element to one of the available contexts, or make the host provide "${boundName}".`,
    {
      boundContext: boundName,
      elementId,
      elementType,
      availableRowContexts: rowContexts,
      availablePageContexts: pageContexts,
    },
  );
}

export function resolveNamedContextEntityId(vm, contextName) {
  const scoped = typeof vm.scopedProvidedContexts === "function"
    ? vm.scopedProvidedContexts()
    : vm.scopedProvidedContexts;
  const pages = typeof vm.pageEntities === "function" ? vm.pageEntities() : vm.pageEntities;

  const fromScoped = scopedContextId(scoped, contextName);
  if (fromScoped) {
    return Number(fromScoped) || fromScoped;
  }
  const fromPage = pages?.[contextName];
  if (fromPage) {
    return Number(fromPage) || fromPage;
  }
  return 0;
}

export function resolveBoundEntityId(vm, defaultContextName, urlFallback = null) {
  const { entityId } = vm;
  if (entityId !== undefined && entityId !== null && entityId !== 0 && entityId !== "0") {
    return entityId;
  }
  const scoped = typeof vm.scopedProvidedContexts === "function"
    ? vm.scopedProvidedContexts()
    : vm.scopedProvidedContexts;
  const pages = typeof vm.pageEntities === "function" ? vm.pageEntities() : vm.pageEntities;

  const boundName = readBoundContextName(vm);
  if (boundName) {
    const fromBoundScope = scopedContextId(scoped, boundName);
    if (fromBoundScope) {
      return Number(fromBoundScope) || fromBoundScope;
    }
    const fromBoundPage = pages?.[boundName];
    if (fromBoundPage) {
      return Number(fromBoundPage) || fromBoundPage;
    }
    if (boundName !== defaultContextName) {
      reportUnresolvedBinding(vm, boundName, scoped, pages);
      return 0;
    }
  }

  const fromScoped = scopedContextId(scoped, defaultContextName);
  if (fromScoped) {
    return Number(fromScoped) || fromScoped;
  }
  const fromPage = pages?.[defaultContextName];
  if (fromPage) {
    return Number(fromPage) || fromPage;
  }
  return (typeof urlFallback === "function" ? urlFallback() : 0) || 0;
}
